import ProxyUrl from '../../constants/ProxyUrls'
import axios from 'axios'

export const actions = {
  async findAll(context: any, reclamationId: any) {
    const params = {}
    if (reclamationId) {
      //@ts-ignore
      params.reclamationId = reclamationId
    }

    return await axios
      .get(`${ProxyUrl.getallreclamationemails}`, { params })
      .then((response) => {
        if (response.status === 200) {
          return response.data.responseData
        } else throw new Error('No content')
      })
      .catch((error) => {
        throw error
      })
  },

  async findByPk(context: any, payload: any) {
    return axios
      .get(`/getreclamationemail/${payload.id}`, payload)
      .then((response) => {
        if (response.status === 200) {
          const emailData = response.data.responseData
          return emailData
        } else {
          throw new Error('No Content')
        }
      })
      .catch((error) => {
        throw error
      })
  },

  async addItem(context: any, payload: any) {
    return await axios
      .post(`${ProxyUrl.createreclamationemail}`, payload)
      .then((response) => {
        if (response.status === 200) {
          return true
        } else return false
      })
      .catch((error) => {
        throw error
      })
  },

  async updateItem(context: any, payload: any) {
    return await axios
      .put(`${ProxyUrl.updatereclamationemail}`, payload)
      .then((response) => {
        if (response.status === 200) {
          return true
        } else return false
      })
      .catch((error) => {
        throw error
      })
  },

  async deleteItem(context: any, payload: any) {
    return await axios
      .post(`${ProxyUrl.deletereclamationemail}`, payload)
      .then((response) => {
        if (response.status === 200) {
          return true
        } else return false
      })
      .catch((error) => {
        throw error
      })
  },
}
